<template>
    <el-dialog :visible.sync="dialogFormVisible"
               v-mobile-dialog
               :append-to-body="mobile"
               width="90%"
               :close-on-click-modal="false"
               :before-close="handleClose"
               class="meeting-view-dialog"
    >

        <div slot="title" class="dialog-title">
            <span class="text-info font-weight-bold">
                <span class="el-icon-refresh" v-if="!!single.recurrent_info"></span>
                <span :class="single.is_owner?'el-icon-user-solid':'el-icon-user'"></span> {{ single.id }} </span> | <b>{{
                single.topic
            }} </b>
        </div>
        <el-tabs v-model="tab_index" class="position-relative" :class="mobile?'h-100':''">
            <!-- 会议信息 -->
            <el-tab-pane label="会议信息" name="1" :class="mobile?'':'tab-content'">
                <meeting-view-general-info :approve_form="approve_form" :btn_approve="btn_approve" :emails="emails"
                              @invitation="goInvitation" @approve="handleApprove"
                              @copy="handleCopyMeetingInfo" :mobile="mobile" :single="single"/>

            </el-tab-pane>
            <!--周期性会议的详细情况-->
            <el-tab-pane label="周期信息" name="2" v-if="single.recurrent_info" :class="mobile?'':'tab-content'">
                <meeting-view-recurrent-info :single="single"/>

            </el-tab-pane>
            <!--会议的报表-->
            <el-tab-pane label="会议报告" name="3" v-if="single.is_end == 1 && single.is_owner"
                         :class="mobile?'':'tab-content'">
                <meeting-view-visitor-info @participant="downloadParticipantReport"
                              @rebuild="handleRebuildAttendee" :mobile="mobile" :single="single"/>

            </el-tab-pane>
            <!--会议的录像-->
            <el-tab-pane label="会议录像" name="4" v-if="single.is_end == 1 && single.is_owner"
                         :class="mobile?'':'tab-content'">
                <meeting-view-recording-info
                              @rebuild="handleRebuildRecord"
                              @resend="handleResentRecordNotice"
                              @share="handleUpdateShareMode"
                                             :mobile="mobile"
                              @clipboard="copyClipboard"
                              :single="single" :tab_index="tab_index"/>
            </el-tab-pane>
            <!--会议转写-->
            <el-tab-pane label="会议转写" name="5" v-if="single.is_end == 1 && single.is_owner && single.platform_code == 1"
                         :class="mobile?'':'tab-content'">
                <meeting-view-transcription-info :single="single" :active="tab_index === '5'"/>
            </el-tab-pane>
        </el-tabs>

        <div slot="footer" class="dialog-footer">
            <small class="mt-1 pull-left text-muted text-left"
                   v-if="!mobile && (btn_start_meeting && !(parseInt(single.is_end) == 1) || (! single.is_approved))">
                开启会议将开启新窗口,如无法弹出,<br/>请检查是否被浏览器拦截.</small>

            <span :hidden="(parseInt(single.is_end) == 1) || (! single.is_approved)" v-if="single.is_owner"
                  class="mr-2">
                <el-button v-if="btn_start_meeting" plain class="mb-3 mx-1"
                           type="success" @click="$emit('start')"
                           icon="el-icon-location">{{ $organization.use_label ? '免登入会' : '主持会议' }}
                </el-button>

                <!-- 添加一个按钮，内容是给自发送邮件，仅是自己的才能看见此按钮发送 -->
                <el-button v-if="btn_start_meeting" type="primary" @click="sendHostNotification" icon="el-icon-postcard"
                           class="mx-1 mb-3">重发通知
                </el-button>

                <popup-confirm title="删除会议" @confirm="handleDelete" class="mx-1 mb-3">
                    <el-button v-if="btn_delete" plain icon="el-icon-delete" type="danger">删除
                    </el-button>
                </popup-confirm>
                <el-button v-if="btn_modify" plain class="mx-1 mb-3"
                           type="primary" @click="handleModify" icon="el-icon-edit">修改
                </el-button>
            </span>
            <el-button type="info" @click="$emit('cancel')" icon="el-icon-close" class="mx-1">关闭</el-button>
        </div>

        <el-dialog title="邀请函" :visible.sync="invitation" append-to-body width="360px" v-if="!mobile">
            <img :src="previewImage" width="320px">
        </el-dialog>

        <!-- 导出所用到的excel表格 -->
        <meeting-detail-report-table :meeting="meeting" :emails="emails" ref="meeting_report_excel_detail"></meeting-detail-report-table>

        <el-drawer append-to-body v-if="mobile"
                   title="邀请函"
                   :with-header="false"
                   :visible.sync="invitation"
                   size="90%">
            <div class="text-center mt-5">
                <img :src="previewImage" style="max-width: 100%">
            </div>
            <div class="line my-3"></div>
            <div>
                <el-button type="info" plain class="w-100" @click="invitation=false" icon="el-icon-close">关闭
                </el-button>
            </div>
        </el-drawer>

    </el-dialog>
</template>

<script>
import PopupConfirm from "./popup-confirm";
import axios from "axios"
import CommonMixin from "@/common/mixins/common-mixin";
import MeetingDetailReportTable from "./meeting-detail-report-table.vue";
import MeetingViewVisitorInfo from "@/components/meeting-view-visitor-info.vue";
import MeetingViewGeneralInfo from "@/components/meeting-view-general-info.vue";
import MeetingViewRecordingInfo from "@/components/meeting-view-recording-info.vue";
import MeetingViewRecurrentInfo from "@/components/meeting-view-recurrent-info.vue";
import MeetingViewTranscriptionInfo from "@/components/meeting-view-transcription-info.vue";

export default {
    name: "meeting-view",
    mixins: [CommonMixin],
    data() {
        return {
            poll_view: false,
            poll_data: {},
            dialogFormVisible: false,
            approve_form: {approve_result: '2'},
            qrcode: null,
            previewImage: null,
            invitation: false,
            tab_index: "1",
            meeting: {},
            record_tab: '1',
        }
    },
    components: {
        MeetingViewTranscriptionInfo: MeetingViewTranscriptionInfo,
        MeetingViewRecurrentInfo: MeetingViewRecurrentInfo,
        MeetingViewRecordingInfo: MeetingViewRecordingInfo,
        MeetingViewGeneralInfo: MeetingViewGeneralInfo,
        MeetingViewVisitorInfo: MeetingViewVisitorInfo,
        MeetingDetailReportTable,
        PopupConfirm},
    props: {
        view_mode: {
            type: [Number, Boolean],
            default() {
                return false;
            }
        },
        rebuild: {
            type: Boolean,
            default() {
                return false;
            }
        },
        single: {
            type: Object,
            default() {
                return {};
            }
        },
        btn_start_meeting: {
            type: Boolean,
            default() {
                return true;
            }
        },
        btn_approve: {
            type: [Boolean, Number],
            default() {
                return false;
            }
        },
        btn_modify: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_delete: {
            type: Boolean,
            default() {
                return false;
            }
        },
        btn_poll: {
            type: Boolean,
            default() {
                return false;
            }
        },
        mobile: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    computed: {
        emails() {
            let data = [];
            if (this.single.attendees) {
                try {
                    data = JSON.parse(this.single.attendees);
                } catch (e) {
                    console.log(e)
                }
            }
            return data;
        },
        invisible() {
            return this.$organization.org === 'sjtu';
        },
        meeting_type() {
            const type = this.single.platform_code;
            if (type === 0) {
                return "ZOOM会议";
            } else if (type === 1) {
                return "腾讯会议";
            } else if (type === 2) {
                return "中目会议";
            } else if (type === 3) {
                return "瞩目会议";
            } else if (type === 4) {
                return "WeLink会议";
            }
            return "视频会议";
        }
    },
    watch: {
        view_mode: {
            handler(newVal) {
                this.dialogFormVisible = !!newVal;
                this.tab_index = "1";
                this.record_tab = "1";
            }
        },
    },
    filters: {
        meetingStatues(value) {
            // 截取value的1-19位字符
            const start = value.slice(0, 19);
            // 截取value的倒数19位字符
            const end = value.slice(-19);
            const meeting_start = new Date(start.replace(/-/g, '/'));
            const meeting_end = new Date(end.replace(/-/g, '/'));
            const now = new Date();

            if (now < meeting_start) return '未开始';
            if (now > meeting_end) return '已结束';

            return '正在进行';
        },
        repeatMeaning(value) {
            if (value == '1') return '每天循环';
            if (value == '2') return '每周循环';
            if (value == '3') return '每月循环';
            return '不重复';
        }
    },
    methods: {
        copyClipboard(str) {
            console.log(str);
            this.$copyText(str).then(() => {
                this.$notice.success('已经复制到剪贴板');
            }).catch(() => {
                this.$notice.error('复制失败,请手动复制');
            });
        },
        handleCopyMeetingInfo() {
            const str = "请参加视频会议 \n"
                + "会议主题：" + this.single.topic + "\n "
                + "会议时间：" + this.single.meeting_date + " " + this.single.meeting_time + " (" + this.single.duration + ")\n"
                + "点击链接入会，或添加至会议列表：\n"
                + this.single.join_url + "\n"
                + "\n#" + this.meeting_type + "：" + this.single.meeting_id + "\n"
                + "会议密码：" + (this.single.password ? this.single.password : "无");
            this.copyClipboard(str);
        },
        downloadParticipantReport() {
            const vm = this;
            const id = this.single.id;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id, review: true, polls: true}, true).then(res => {
                vm.meeting = res.data.data;
                this.$nextTick(function () {
                    vm.$refs['meeting_report_excel_detail'].exportExcel();
                })
            });
        },
        handleClose(done) {
            done();
            this.$emit('cancel');
        },
        handleApprove() {
            if (this.approve_form.approve_result > 0) {
                if (!this.approve_form.reject_reason && this.approve_form.approve_result == 1) {
                    this.$messageBox.error('请填写拒绝理由!');
                } else {
                    this.$emit('approve', this.approve_form);
                }
            }
        },
        handleResetHost() {
            this.$api('Admin.Meeting.ResetHost', this.single, 1).then(() => {
                this.$notice.success('重置成功!');
            });
        },
        handleModify() {
            this.$router.push('/edit/' + this.single.id);
        },
        handleDelete() {
            this.$emit('delete');
        },
        goInvitation() {
            axios.post(this.$apiUrl('User.Invitation'), {id: this.single.id}, {
                headers: {'user-token': this.$mixToken( this.$store.getters['user/token'] )},
                responseType: "arraybuffer"
            }).then(res => {
                return 'data:image/png;base64,' + btoa(
                    new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            }).then(data => {
                this.previewImage = data //图片地址 <img src='data' />
                this.invitation = true;
            });
        },
        openPoll(id) {
            this.$api('Admin.Poll.Get', {id: id}, true).then(res => {
                this.poll_data = res.data.data;
                this.poll_view = true;
            });
        },
        handleRebuildAttendee() {
            this.$api('Query.Rebuild.Attendee', {id: this.single.id}, true).then(() => {
                this.$notice.success('参会者重新下载完成！');
                this.$emit('cancel');
            });
        },
        handleRebuildRecord() {
            this.$api('Query.Rebuild.Record', {id: this.single.id}, true).then(() => {
                this.$notice.success('录像重新下载完成！');
                this.$emit('cancel');
            });
        },
        handleResentRecordNotice() {
            this.$api('Query.Resend.RecordNotice', {id: this.single.id}, true).then(() => {
                this.$notice.success('录像通知邮件已经发送！');
            });
        },
        sendHostNotification() {
            this.$api('Query.Resend.HostNotice', {id: this.single.id}, true).then(() => {
                this.$notice.success('会议邀请邮件已经发送给主持人！');
            });
        },
        handleUpdateShareMode(row) {
            const data = {
                id: row.id,
                share_mode: row.share_mode,
                password: row.password,
                allow_download: row.allow_download,
                disable_password: row.disable_password,
            };
            if (data.share_mode < '0' || data.share_mode > '3') {
                this.$notice.error('分享对象选择错误');
                return;
            }
            //正则运算判断密码是8位数字和字母,并且有一个大写字母一个小写字母以及数字
            if (row.disable_password != 1) {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/.test(data.password))) {
                    this.$notice.error('如果自己设置，密码必须是8位数字和字母的组合,必须要有1个大写字母一个小写字母和数字');
                    return;
                }
            }

            this.$api('Report.Meeting.Detail.UpdateShareMode', data, 1).then(() => {
                this.$emit('cancel');
                this.$notice.success('更新成功');
            });
        },
    }
}
</script>

<style lang="scss">

.meeting-view-dialog {
    .el-dialog__body {
        padding: 10px 20px !important;
    }

    .tab-content {
        height: calc(75vh - 186px);
        overflow-x: hidden;
        overflow-y: auto;
    }

    .copy-btn {
        padding: 2px 5px;
    }

    .dialog-title {
        margin-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

}

.approve_form {
    margin-top: 20px;
    padding: 10px 20px 5px;
    background-color: #FFFDE7;
    text-align: center;

    .el-form-item {
        margin-bottom: 0;
    }
}

.qrcode {
    height: 120px;
    width: 120px;
}

.mobile-dialog__outer {
    .el-tabs__content {
        height: calc(100% - 55px);
        overflow-x: hidden;
        overflow-y: auto;
    }
}

</style>
